import { isNullOrUndefined } from "$/utils/gates"

import { buildCssClassName } from "@/3514/utils"
import { sanitizeContent } from "@/utils/common"

type Props = {
    order: number | null
    question: string
    isRequired?: boolean
    className?: string
}

const QuestionRow = ({ order, question, isRequired = false, className = "" }: Props) => {
    return question ? (
        <div className={buildCssClassName("mb-3 d-flex text-gray-100", className)}>
            {isNullOrUndefined(order) ? null : <span className="font-extrabold mr-1">{order}. </span>}
            <span
                dangerouslySetInnerHTML={{
                    __html: sanitizeContent(`${question}${isRequired ? "*" : ""}`, { allowedTags: [] })
                }}
            />
        </div>
    ) : null
}

export default QuestionRow
